// libs
import { styled } from '@nykaa/ui-components';

//constants
import { MWEB_HEADER_ZINDEX } from 'shared/styles/base';

export const Container = styled.div`
  width: fit-content;
  box-shadow: ${({ theme }) => theme.elevations.shadow100};
  border-radius: ${({ theme }) => theme.borders.radius10};
  background-color: ${({ theme }) => theme.colors.surface};
  z-index: ${MWEB_HEADER_ZINDEX - 1};
`;

export const PopUpWrapper = styled.div`
  display: flex;
`;

export const Subheading = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const Wrapper = styled.div`
  position: relative;
`;
